/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	initiatedDate?: string;
	remarks: string;
	onRemarksChange: (value: string) => void;
	readOnly?: boolean;
}
const MBCProfileCard = ({
	initiatedDate, 
	remarks,
	onRemarksChange,
	readOnly = false,
	}: Props) => {
	const { t } = useTranslation();
	var storedData = localStorage.getItem("userDetails");
	const userDetails = storedData ? JSON.parse(storedData) : null;
	return (
		<div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden flex flex-col h-full">
			<div className="px-6 py-2 border-b border-slate-100 flex items-center gap-2">
				<div className="w-6 h-6 rounded-md bg-[#2D3E50] text-white flex items-center justify-center text-[10px] font-black">
					03
				</div>
				<h3 className="text-[10px] font-black text-[#2D3E50] uppercase tracking-widest mt-2">
					{t("mediaBatchInit.creation.validation&Remarks")}
				</h3>
			</div>
			<div className="p-6 space-y-3 flex-1">
				<div className="space-y-2">
					<div className="space-y-1.5">
						<label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block">
							{t("mediaBatchInit.creation.batchInitiatedBy")}
						</label>
						<div className="flex items-center gap-3 bg-slate-50 border border-slate-100 rounded-xl p-3">
							<span className="material-symbols-outlined text-slate-300">
								person
							</span>
							<span className="text-[11px] font-black text-slate-600">
								{userDetails?.[0]?.first_name +
									" " +
									userDetails?.[0]?.last_name}
							</span>
						</div>
					</div>
					<div className="space-y-1.5">
						<label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block">
							{t("mediaBatchInit.creation.initiationTimestamp")}
						</label>
						<div className="flex items-center gap-3 bg-slate-50 border border-slate-100 rounded-xl p-3">
							<span className="material-symbols-outlined text-slate-300">
								event_available
							</span>
							<span className="text-[11px] font-black text-slate-600 font-mono tracking-tighter">
								{initiatedDate ?? ""}
							</span>
						</div>
					</div>
				</div>

				<div className="space-y-1">
					<label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block">
						{t("mediaBatchInit.creation.processRemarks")}
					</label>
					<textarea
						value={remarks}
						onChange={(e) => onRemarksChange(e.target.value)}
						readOnly={readOnly}
						placeholder={t("mediaBatchInit.creation.remarksPlaceholder")}
						className="w-full bg-slate-50/30 border border-slate-100 rounded-xl p-4 text-[10px] font-medium text-slate-600 outline-none min-h-[68px] resize-none focus:bg-white focus:ring-2 focus:ring-orange-500/10 focus:border-orange-200 transition-all"
					></textarea>
				</div>

				<div className="pt-2 border-t border-slate-100">
					<div className="bg-[#EEF6FF] border border-blue-100 rounded-2xl p-4">
						<div className="flex items-center gap-3 mb-2 text-blue-600">
							<span className="material-symbols-outlined text-sm font-black">
								info
							</span>
							<span className="text-[10px] font-black uppercase tracking-[0.2em]">
								{t("mediaBatchInit.creation.sopReference")}
							</span>
						</div>
						<p className="text-[11px] text-blue-800 italic leading-relaxed font-medium">
							"{t("mediaBatchInit.creation.sopReferenceText")}"
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MBCProfileCard;
